<template>
    <div class="custom-image-upload-wrapper" :class="data.wrapperClass">
        <div class="image-area d-flex">
            <img v-if="imageUrl"
                 :src="imageUrl"
                 alt=""
                 class="img-fluid mx-auto my-auto"/>
        </div>
        <div class="input-area">
            <label
                id="upload-label"
                :for="inputFieldId">
                {{ data.label }}
            </label>
            <input
                :id="inputFieldId"
                type="file"
                :disabled="data.disabled"
                v-on="listeners"
                class="form-control d-none"
            />
        </div>
    </div>
</template>

<script>
import {InputMixin} from './mixin/InputMixin.js';
import {FileUploaderMixin} from './mixin/FileUploaderMixin.js';

export default {
    name: "CustomImageUpload",
    mixins: [InputMixin, FileUploaderMixin],
    data() {
        return {
            imageUrl: '',
            objectUrl: null, // Example: blob:http://0.0.0.0:83/d41b022b-91db-4a6c-8af0-a34f8080fc14
        }
    },
    watch: {
        value: {
            handler: 'initComponent',
            immediate: true
        }
    },
    beforeDestroy() {
        this.revokeObjectUrl();
    },
    methods: {
        getFile(event) {
            let file = event.target.files[0];
            this.fieldValue = file;
            if (file) {
                this.setPreviewFromFile(file);
            } else {
                this.resetPreview();
            }
            this.changed();
        },
        changed() {
            this.$emit('input', this.fieldValue);
        },
        initComponent() {
            if (this.isFile(this.value)) {
                this.fieldValue = this.value;
                this.setPreviewFromFile(this.value);
                return;
            }
            if (typeof this.value == 'string') {
                if (this.value) {
                    this.imageUrl = this.value;

                    this.getDataUrl(this.value)
                        .then(data => {
                            this.fieldValue = data;

                            if (this.fieldValue)
                                this.changed();
                        });
                } else {
                    this.resetPreview();
                }
            }
            if (!this.value) {
                this.resetPreview();
            }
        },
        isFile(value) {
            return typeof File !== "undefined" && value instanceof File;
        },
        setPreviewFromFile(file) {
            if (!file) {
                this.resetPreview();
                return;
            }
            const useExternalUrl = file.url && typeof file.url === 'string';
            if (!useExternalUrl) {
                this.revokeObjectUrl();
            }
            let url = '';
            if (useExternalUrl) {
                url = file.url;
            } else if (typeof URL !== "undefined" && typeof URL.createObjectURL === "function") {
                url = URL.createObjectURL(file);
                this.objectUrl = url;
            }
            this.imageUrl = url;
        },
        resetPreview() {
            this.revokeObjectUrl();
            this.imageUrl = "";
            this.fieldValue = "";
        },
        revokeObjectUrl() {
            // Revoke previous object URL to avoid memory leaks
            if (this.objectUrl && typeof URL !== "undefined" && typeof URL.revokeObjectURL === "function") {
                URL.revokeObjectURL(this.objectUrl);
            }
            this.objectUrl = null;
        }
    }
}
</script>
